import React, { useContext } from 'react';
import localisation from '../../localisation.json';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import { LanguageContext } from '../App';
import { Repeat } from 'react-feather';
import { RestartContext } from '../RestartContext/RestartContext';
import Statistics from '../Statistics/Statistics';

function Header() {
    const { language, setLanguage } = useContext(LanguageContext);
    const { triggerRestart } = React.useContext(RestartContext);
    return (
        <header>
            <LanguageSelector language={language} setLanguage={setLanguage} />
            <h1>{localisation[0].header[language]}</h1>
            <div style={{ display: 'flex', gap: 5 }}>
                <Statistics />
                <button onClick={triggerRestart} className='hoverable-btn'>
                    <Repeat className='header-icon' />
                </button>
            </div>
        </header>
    );
}

export default Header;
